import { __spreadArray } from "tslib";
import React from "react";
import s from './badge.module.css';
import PropTypes from "prop-types";
export function Badge(_a) {
    var leadIcon = _a.leadIcon, children = _a.children, tailIcon = _a.tailIcon, size = _a.size, type = _a.type, className = _a.className;
    var classNames = __spreadArray([
        s.badge,
        s[size],
        s[type]
    ], (className ? [className] : []), true);
    return (React.createElement("span", { className: classNames.join(' ') },
        leadIcon || null,
        children,
        tailIcon || null));
}
Badge.propTypes = {
    leadIcon: PropTypes.node,
    tailIcon: PropTypes.node,
    size: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
    type: PropTypes.oneOf(['neutral', 'destructive', 'warning', 'success', 'white']).isRequired,
    className: PropTypes.string,
};
//# sourceMappingURL=Badge.js.map